// AUTO-GENERATED from Firestore dump. Do not edit by hand.
// Source: scripts/build-static-config.mjs (config version 23)

import type { TvmFormDefinition } from "../types";
import _inline_1 from "../../assets/hints/inline/towCable_1.png";
import _inline_2 from "../../assets/hints/inline/towCable_2.png";
import _inline_3 from "../../assets/hints/inline/towCable_3.png";
import _inline_4 from "../../assets/hints/inline/towCable_4.png";
import _inline_5 from "../../assets/hints/inline/towCable_5.png";
import _inline_6 from "../../assets/hints/inline/towCable_6.png";
import _inline_7 from "../../assets/hints/inline/towCable_7.png";

const form: TvmFormDefinition = {
	"hints": {
		"htmlDef": "<div style=\"font-family: Helvetica; font-size: 20px\">    <p>{{form_tow_cable_hints_p1}}</p>    <div>       <p>{{form_tow_cable_hints_p2}}<img src=\"{{__inline_towCable_1}}\"/></p>       <p><img src=\"{{__inline_towCable_2}}\"/> </p>    </div>    <div>       <p>{{form_tow_cable_hints_p3}}</p>       <p>{{form_tow_cable_hints_p4}}</p>       <p>{{form_tow_cable_hints_p5}}</p>       <ol>          <li>{{form_tow_cable_hints_p6}}</li>          <li>{{form_tow_cable_hints_p7}}</li>       </ol>    </div>    <p>{{form_tow_cable_hints_p8}}</p>    <p style=\"text-align: left\">           <span style=\"font-size: 14px; font-family: Helvetica\"             ><img               src=\"{{__inline_towCable_3}}\"               style=\"                 float: left;                 display: inline-block;                 text-align: left;                 width: 88px;               \"           /></span>         </p>    <div>       <p>{{form_tow_cable_hints_p9}}</p>       <p>{{form_tow_cable_hints_p10}}</p>       <ol>          <li>{{form_tow_cable_hints_p11}}</li>          <li>{{form_tow_cable_hints_p12}}</li>          <li>{{form_tow_cable_hints_p13}}</li>          <li>{{form_tow_cable_hints_p14}}</li>          <li>{{form_tow_cable_hints_p15}}</li>          <li>{{form_tow_cable_hints_p16}}</li>          <li>{{form_tow_cable_hints_p17}}</li>          <li>{{form_tow_cable_hints_p18}}</li>          <li>{{form_tow_cable_hints_p19}}</li>          <li>{{form_tow_cable_hints_p20}}</li>       </ol>       <p>{{form_tow_cable_hints_p21}}</p>       <p><strong>{{form_tow_cable_hints_p22}}</strong></p>       <p>{{form_tow_cable_hints_p23}}</p>       <p>{{form_tow_cable_hints_p24}}</p>       <p><strong>{{form_tow_cable_hints_p25}}</strong>              <p>{{form_tow_cable_hints_p26}}</p>       <p>{{form_tow_cable_hints_p27}}</p>       <p>{{form_tow_cable_hints_p28}}</p>       <p>{{form_tow_cable_hints_p29}}</p>       <p>             <span               ><strong                 style=\"                   font-weight: 700;                   color: rgb(0, 0, 0);                   font-family: Helvetica;                   font-size: 20px;                   font-style: normal;                   font-variant-ligatures: normal;                   font-variant-caps: normal;                   letter-spacing: normal;                   orphans: 2;                   text-align: start;                   text-indent: 0px;                   text-transform: none;                   white-space: normal;                   widows: 2;                   word-spacing: 0px;                   -webkit-text-stroke-width: 0px;                   text-decoration-thickness: initial;                   text-decoration-style: initial;                   text-decoration-color: initial;                 \"                 ><img                   src=\"{{__inline_towCable_4}}\"                   style=\"width: 733px\" /><img                   src=\"{{__inline_towCable_5}}\"                   style=\"width: 718px\" /></strong               ><br             /></span>           </p>       <p><strong>{{form_tow_cable_hints_p30}}</strong></p>       <p>{{form_tow_cable_hints_p31}}</p>       <p>{{form_tow_cable_hints_p32}}</p>       <p style=\"text-align: center\">             <span               ><img                 src=\"{{__inline_towCable_6}}\"                 style=\"width: 329px\"             /></span>           </p>       <p>{{form_tow_cable_hints_p33}}</p>       <ol>          <li>{{form_tow_cable_hints_p34}}</li>          <li>{{form_tow_cable_hints_p35}}</li>          <li>{{form_tow_cable_hints_p36}}</li>          <li>{{form_tow_cable_hints_p37}}</li>          <li>{{form_tow_cable_hints_p38}}</li>          <li>{{form_tow_cable_hints_p39}}</li>       </ol>       <p>{{form_tow_cable_hints_p40}}</p>       <p>                 <span style=\"font-size: 14px; font-family: Helvetica\"                   ><img                     src=\"{{__inline_towCable_7}}\"                     style=\"width: 788px\" /></span                 ><span                   ><br                 /></span>               </p>       <p>{{form_tow_cable_hints_p41}}</p>    </div> </div>",
		"title": "Cables de arrastre"
	},
	"fields": {
		"mainPower": {
			"name": "mainPower",
			"value": 0,
			"index": 0,
			"label": "$form_tow_cable_main_power",
			"type": "INPUT",
			"inputType": "number"
		}
	},
	"formula": {
		"__cond": {
			"mainPower >= 1500 && mainPower < 2000": {
				"maxCableDiameter": {
					"value": 26,
					"label": "Maximo diametro cable mm"
				},
				"minWeight": {
					"label": "Peso / m kg AT",
					"value": 2.18
				},
				"maxBreakingLoadAM": {
					"value": 42.354,
					"label": "Carga Rotura AM"
				},
				"maxBreakingLoadAT": {
					"label": "Carga Rotura AT",
					"value": 38.427
				},
				"maxWeightAM": {
					"label": "Peso / m kg AM",
					"value": 2.87
				},
				"maxWeightAT": {
					"label": "Peso / m kg AT",
					"value": 2.67
				},
				"minBreakingLoad": {
					"value": 32.946,
					"label": "Carga Rotura"
				},
				"minCableDiameter": {
					"value": 24,
					"label": "Diámetro Cable"
				}
			},
			"mainPower >= 1200 && mainPower < 1500": {
				"maxBreakingLoadAT": {
					"label": "Carga Rotura AT",
					"value": 32.946
				},
				"maxCableDiameter": {
					"label": "Maximo diametro cable mm",
					"value": 24
				},
				"minWeight": {
					"label": "Peso / m kg AT",
					"value": 0.97
				},
				"maxBreakingLoadAM": {
					"label": "Carga Rotura AM",
					"value": 36.189
				},
				"maxWeightAT": {
					"label": "Peso / m kg AT",
					"value": 2.18
				},
				"minBreakingLoad": {
					"label": "Carga Rotura",
					"value": 14.688
				},
				"minCableDiameter": {
					"label": "Diámetro Cable",
					"value": 16
				},
				"maxWeightAM": {
					"label": "Peso / m kg AM",
					"value": 2.32
				}
			},
			"mainPower >= 2500 && mainPower < 3000": {
				"maxBreakingLoadAT": {
					"label": "Carga Rotura AT",
					"value": 44.821
				},
				"minWeight": {
					"value": 2.94,
					"label": "Peso / m kg AT"
				},
				"maxBreakingLoadAM": {
					"value": 52.7,
					"label": "Carga Rotura AM"
				},
				"maxCableDiameter": {
					"label": "Maximo diametro cable mm",
					"value": 30
				},
				"minCableDiameter": {
					"value": 28,
					"label": "Diámetro Cable"
				},
				"minBreakingLoad": {
					"label": "Carga Rotura",
					"value": 41.505
				},
				"maxWeightAT": {
					"label": "Peso / m kg AT",
					"value": 3.23
				},
				"maxWeightAM": {
					"label": "Peso / m kg AM",
					"value": 3.4
				}
			},
			"mainPower >= 3000 && mainPower < 4500": {
				"maxWeightAM": {
					"label": "Peso / m kg AM",
					"value": 3.6
				},
				"minCableDiameter": {
					"value": 28,
					"label": "Diámetro Cable"
				},
				"minBreakingLoad": {
					"label": "Carga Rotura",
					"value": 41.505
				},
				"maxWeightAT": {
					"label": "Peso / m kg AT",
					"value": 3.45
				},
				"minWeight": {
					"value": 2.94,
					"label": "Peso / m kg AT"
				},
				"maxBreakingLoadAM": {
					"value": 56.192,
					"label": "Carga Rotura AM"
				},
				"maxCableDiameter": {
					"label": "Maximo diametro cable mm",
					"value": 32
				},
				"maxBreakingLoadAT": {
					"label": "Carga Rotura AT",
					"value": 47.9
				}
			},
			"mainPower >= 800 && mainPower < 1200": {
				"maxWeightAM": {
					"value": 1.74,
					"label": "Peso / m kg AM"
				},
				"minCableDiameter": {
					"label": "Diámetro Cable",
					"value": 15
				},
				"minBreakingLoad": {
					"value": 12.954,
					"label": "Carga Rotura"
				},
				"maxWeightAT": {
					"label": "Peso / m kg AT",
					"value": 1.22
				},
				"minWeight": {
					"label": "Peso / m kg AT",
					"value": "0.87"
				},
				"maxBreakingLoadAM": {
					"value": 23.2,
					"label": "Carga Rotura AM"
				},
				"maxCableDiameter": {
					"value": 18,
					"label": "Maximo diametro cable mm"
				},
				"maxBreakingLoadAT": {
					"value": 18.642,
					"label": "Carga Rotura AT"
				}
			},
			"mainPower >= 500 && mainPower < 800": {
				"maxWeightAM": {
					"value": 1.62,
					"label": "Peso / m kg AM"
				},
				"maxWeightAT": {
					"value": 1.1,
					"label": "Peso / m kg AT"
				},
				"minBreakingLoad": {
					"value": 10.418,
					"label": "Carga Rotura"
				},
				"minCableDiameter": {
					"label": "Diámetro Cable",
					"value": 13
				},
				"maxCableDiameter": {
					"label": "Maximo diametro cable mm",
					"value": 17
				},
				"minWeight": {
					"label": "Peso / m kg AT",
					"value": 0.68
				},
				"maxBreakingLoadAM": {
					"value": 21.9,
					"label": "Carga Rotura AM"
				},
				"maxBreakingLoadAT": {
					"value": 16.665,
					"label": "Carga Rotura AT"
				}
			},
			"mainPower >= 2000 && mainPower < 2500": {
				"minCableDiameter": {
					"label": "Diámetro Cable",
					"value": 26
				},
				"minBreakingLoad": {
					"value": 38.427,
					"label": "Carga Rotura"
				},
				"maxWeightAT": {
					"value": 2.94,
					"label": "Peso / m kg AT"
				},
				"maxWeightAM": {
					"value": 3.15,
					"label": "Peso / m kg AM"
				},
				"maxBreakingLoadAT": {
					"label": "Carga Rotura AT",
					"value": 41.505
				},
				"minWeight": {
					"value": 2.87,
					"label": "Peso / m kg AT"
				},
				"maxBreakingLoadAM": {
					"value": 49.168,
					"label": "Carga Rotura AM"
				},
				"maxCableDiameter": {
					"label": "Maximo diametro cable mm",
					"value": 28
				}
			},
			"mainPower >= 4500 && mainPower < 5000": {
				"maxCableDiameter": {
					"label": "Maximo diametro cable mm",
					"value": 34
				},
				"minWeight": {
					"label": "Peso / m kg AT",
					"value": 3.45
				},
				"maxBreakingLoadAM": {
					"value": 59.704,
					"label": "Carga Rotura AM"
				},
				"maxBreakingLoadAT": {
					"value": 50.8,
					"label": "Carga Rotura AT"
				},
				"maxWeightAM": {
					"value": 3.9,
					"label": "Peso / m kg AM"
				},
				"maxWeightAT": {
					"label": "Peso / m kg AT",
					"value": 3.7
				},
				"minCableDiameter": {
					"label": "Diámetro Cable",
					"value": 32
				},
				"minBreakingLoad": {
					"label": "Carga Rotura",
					"value": 47.9
				}
			},
			"mainPower >= 200 && mainPower < 500": {
				"minCableDiameter": {
					"value": 12,
					"label": "Diámetro Cable"
				},
				"minBreakingLoad": {
					"label": "Carga Rotura",
					"value": 9.617
				},
				"maxWeightAT": {
					"value": "0.80",
					"label": "Peso / m kg AT"
				},
				"maxWeightAM": {
					"label": "Peso / m kg AM",
					"value": 1.3
				},
				"maxBreakingLoadAT": {
					"value": 11.22,
					"label": "Carga Rotura AT"
				},
				"minWeight": {
					"value": 0.63,
					"label": "Peso / m kg AT"
				},
				"maxBreakingLoadAM": {
					"label": "Carga Rotura AM",
					"value": 18.044
				},
				"maxCableDiameter": {
					"label": "Maximo diametro cable mm",
					"value": "14"
				}
			}
		}
	}
};

if (form.hints) {
	form.hints.htmlDef = form.hints.htmlDef
		.split("{{__inline_towCable_1}}").join(_inline_1)
		.split("{{__inline_towCable_2}}").join(_inline_2)
		.split("{{__inline_towCable_3}}").join(_inline_3)
		.split("{{__inline_towCable_4}}").join(_inline_4)
		.split("{{__inline_towCable_5}}").join(_inline_5)
		.split("{{__inline_towCable_6}}").join(_inline_6)
		.split("{{__inline_towCable_7}}").join(_inline_7);
}

export const towCable = form;
